<div class="error-tooltip-surface" role="alert" aria-live="polite" aria-atomic="true" [attr.id]="tooltipId || null">
  <ng-content></ng-content>
</div>
